import styles from './Circle.module.css';

function Circle() {
    return <div className={styles['circle']}></div>;
}

export default Circle;
